import { useEffect } from "react";
export default function AccountLabelGuard() {
  useEffect(() => {
    let rafId: number | null = null;
    const enforceStyles = () => {
      const formContainers = "#customer_login, form.login, form.register, form.lost_reset_password, .woocommerce-form-login, .woocommerce-form-register, .woocommerce-ResetPassword, .woocommerce-MyAccount-content";
      const selector = `${formContainers.split(",").map(s => `${s.trim()} label, ${s.trim()} label span`).join(", ")}`;
      const elements = document.querySelectorAll<HTMLElement>(selector);
      elements.forEach(el => {
        const isRequired = el.classList.contains("required");
        const color = isRequired ? "#087db3" : "#111827";
        el.style.setProperty("color", color, "important");
        el.style.setProperty("-webkit-text-fill-color", color, "important");
        el.style.setProperty("opacity", "1", "important");
      });
    };
    const scheduleEnforce = () => {
      if (rafId !== null) return;
      rafId = requestAnimationFrame(() => {
        rafId = null;
        enforceStyles();
      });
    };

    // Run once on mount
    scheduleEnforce();

    // Short timeouts after mount to handle deferred injection/markup hydration
    const timer1 = setTimeout(scheduleEnforce, 300);
    const timer2 = setTimeout(scheduleEnforce, 1200);

    // MutationObserver watching childList changes in document.body
    const observer = new MutationObserver(mutations => {
      let hasChildListChange = false;
      for (const m of mutations) {
        if (m.type === "childList") {
          hasChildListChange = true;
          break;
        }
      }
      if (hasChildListChange) {
        scheduleEnforce();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    return () => {
      if (rafId !== null) {
        cancelAnimationFrame(rafId);
      }
      clearTimeout(timer1);
      clearTimeout(timer2);
      observer.disconnect();
    };
  }, []);
  return null;
}